import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Notification } from 'Components/frameworks/notification/Notification';
type Props = {
  name: string;
  text: string;
  type: string;
};
export const InsuranceFeedback = ({ name, text, type }: Props) => {
  const isError = type === 'error';
  const icon = isError ? ICONS.WARNING : ICONS.CHECK_OUTLINE;
  return (
    <Notification
      className={classnames('bg-transparent', isError ? 'text-red' : 'text-green')}
      data-testid={name}
      iconName={icon}
      iconWidth="1.25rem"
    >
      <p className="m-0 font-sans text-14 leading-normal">{text}</p>
    </Notification>
  );
};
